import React from 'react';
import ContentCijfer from './ContentCijfer';
import ContentHeadline from './ContentHeadline';
import ContentHeroHome from './ContentHeroHome/index';
import ContentCases from './ContentCases'
import ContnetBackgroundImage from './ContnetBackgroundImage';
import ContentHeroSmall from './ContentHeroSmall/index'
import Content from './Content'
import ContentDoing from './ContentDoing';
import ContentQuote from './contentQuote/index'
import ContentMedia from './ContentMedia'
import ContentContact from './ContentContact';
import CTABlock from './CTABlock'

const Styles = {
  HERO: "Hero homepage",
  CIJFERS: "WBO cijfers",
  CASES: "Home | Cases",
  SUCCESVERHALEN: "Succesverhalen",
  BACKGROUNDIMAGE: "Image 800px",
  HEROSMALL: "Hero small",
  DEFAULTTEXT: "Default text",
  DOINGS: "WBO doings",
  OFFERTE: "Werkgevers offerte",
  AANDERSLAG: "Aan de slag",
  COlUMN: "2 column image",
  IMAGE: "Image",
  PAGECASES: "Page cases",
  CONTACT: "Contact",
  CTA: "CTA | grey background | green button",
}

function StyleSorter({ block })
{
  if (block.content.length === 0)
    return null
  // console.log(block)
  switch (block.style?.name ?? block.name)
  {
    case Styles.HERO:
      return (
        <ContentHeroHome blocks={block.content[0].text.blocks} />
      )
    case Styles.CIJFERS:
      return (
        <ContentCijfer cijfers={block.content[0].text.blocks} />
      )
    case Styles.SUCCESVERHALEN:
      return (
        <ContentHeadline {...block.content[0].text.blocks[0]} />
      )
    case Styles.CASES:
      return (
        <ContentCases cases={block.content[0].text.blocks} />
      )
    case Styles.BACKGROUNDIMAGE:
      return (
        <ContnetBackgroundImage image={block.content[0].text.blocks[0].image} />
      )
    case Styles.HEROSMALL:
      return (
        <ContentHeroSmall content={block.content} />
      )
    case Styles.DEFAULTTEXT:
      return (
        <Content content={block.content} />
      )
    case Styles.AANDERSLAG:
      return (
        <Content content={block.content} />
      )
    case Styles.PAGECASES:
      return (
        <Content content={block.content} />
      )
    case Styles.COlUMN:
      return (
        <ContentMedia blocks={block.content[0].text.blocks} columns={2} />
      )
    case Styles.IMAGE:
      return (
        <ContentMedia blocks={block.content[0].text.blocks} columns={1} />
      )
    case Styles.DOINGS:
      return (
        <ContentDoing items={block.content} />
      )
    case Styles.OFFERTE:
      return (
        <ContentQuote items={block.content} />
      )
    case Styles.CONTACT:
      return (
        <ContentContact items={block.content} />
      )
    case Styles.CTA:
      return (
        <CTABlock {...block.content[0]} />
      )
    default:
      return null
  }

}

export default StyleSorter;